import React from 'react';
export function EventDetails() {
  const details = [{
    icon: '📅',
    title: 'FECHA',
    content: 'Lunes 16 de Marzo, 2025'
  }, {
    icon: '📍',
    title: 'LUGAR',
    content: 'Miami, Florida',
    subtext: 'La dirección exacta se envía al registrarte'
  }, {
    icon: '⏱️',
    title: 'DURACIÓN',
    content: '2 horas y media',
    subtext: 'de entrenamiento experiencial'
  }, {
    icon: '🗣️',
    title: 'IDIOMA',
    content: '100% en Español',
    subtext: 'Para nuestra comunidad latina'
  }, {
    icon: '👥',
    title: 'CUPOS',
    content: 'Solo 100 lugares presenciales',
    subtext: 'No hay lista de espera'
  }, {
    icon: '💵',
    title: 'INVERSIÓN',
    content: '💵 Valor normal: $50 · Hoy: $5 · 90% de descuento',
    subtext: 'No porque valga $5 — sino porque no queremos que nada te impida estar ahí'
  }];
  return <section className="py-20 px-4 bg-gray-50 text-[#1a1a2e]" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5B2D8E] mb-4" data-id="element-26">
            Todo lo que necesitas saber
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-27">
          {details.map((detail, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-28">
              <div className="text-4xl mb-4" data-id="element-29">{detail.icon}</div>
              <h3 className="text-sm font-bold tracking-widest text-gray-400 mb-2" data-id="element-30">
                {detail.title}
              </h3>
              <p className="text-xl font-bold text-[#1a1a2e] mb-2" data-id="element-31">
                {detail.content}
              </p>
              {detail.subtext && <p className="text-gray-600 text-sm" data-id="element-32">{detail.subtext}</p>}
            </div>)}
        </div>
      </div>
    </section>;
}